import {Base} from "@/api/Base"

export class InsuranceCompanyDelete extends Base {
    path = "insuranceCompany/delete"
}